import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { createFacultyStart ,editFacultyStart ,deleteFacultyStart } from "../../redux/faculties/reducer";

const useFacultiesEditor = () => {
  const dispatch = useDispatch();

  const createFaculty = useCallback(
    (data) => {
      dispatch(createFacultyStart(data));
    },
    [dispatch]
  );
  const editFaculty = useCallback(
    (data) => {
      dispatch(editFacultyStart(data));
    },
    [dispatch]
  );
 
  const deleteFaculty = useCallback(
    (id) => {
      dispatch(deleteFacultyStart(id));
    },
    [dispatch]
  );
 
  return { createFaculty, editFaculty, deleteFaculty };
};

export default useFacultiesEditor;
